/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { AppContext } from '../App';
import BannersFetcher from '../common/BannersFetcher';
import Loader from '../common/Loader';
import SearchNavbar from '../common/SearchNavbar';
import SportSelector from '../common/SportSelector';
import TopMenuSelector from '../common/TopMenuSelector';
import { BetslipContext } from '../data/betslip/BetslipConf';
import { UserContext } from '../data/betslip/UserConf';
import { TIME_FILTERS } from '../data/constants';
import { existsCountry } from '../data/utils/existsCountry';
import { existsSport } from '../data/utils/existsSport';
import { existsTournament } from '../data/utils/existsTournament';
import { useFetchSeoSettings } from '../data/fetchSeoSettings';
import { SeoContext } from '../data/seo/SeoContextProvider';
import { useHandleSeoSettings } from '../data/seo/seoUtils';
import { setBetslipEventsNumber, setLiveEventsNumber } from '../data/sport-utils';
import { classIf } from '../data/utils/classIf';
import { getConfiguration } from '../data/utils/configuration';
import { nDaysFromNow } from '../data/utils/nDaysFromNow';
import { nHoursFromNow } from '../data/utils/nHoursFromNow';
import { appConfig } from '../appConfig';
import { labels } from '../data/labels';
import RouteSeoPath from '../RouteSeoPath';
import { isBetslipPlayDirectRequest, isOverlaySection } from '../utils/sport-effects';
import EventsByDate from './events-by-date/EventsByDate';
import MultiEventsByDate from './events-by-date/MultiEventsByDate';
import FavoriteOdds from './favorite-odds/FavoriteOdds';
import CategoryMenu from './main-menu/CategoryMenu';
import LandingSports from './main-menu/LandingSports';
import TournamentMenu from './main-menu/TournamentMenu';
import MatchDataFetcher from './match/MatchDataFetcher';
import FavoriteTournaments from './menu/FavoriteTournaments';
import TopMatchMenu from './menu/TopMatchMenu';
import { PrematchDataContext } from './PrematchDataFetcher';
import PrematchLiveMatch from './PrematchLiveMatch';
import TournamentDataFetcher from './tournament/TournamentDataFetcher';
import LastMinute from './widgets/LastMinute';
import Results from './widgets/Results';
import Statistics from './widgets/Statistics';
import TopMatch from './widgets/TopMatch';
import PrematchNoEvents from './PrematchNoEvents';
import ExtraEvents from './extra-events/ExtraEvents';
import { useRouteMatch } from 'react-router-dom';
import ExpandedViewProvider from '../common/ExpandedViewProvider';
import BetBuilderEventFetcher from './bet-builder/BetBuilderEvent';

export const PrematchContext = React.createContext(null);

function Prematch(props) {
    const conf = getConfiguration();
    const appContext = React.useContext(AppContext);
    const seoContext = React.useContext(SeoContext);
    const prematchDataContext = React.useContext(PrematchDataContext);
    const betslipContext = React.useContext(BetslipContext);
    const userContext = React.useContext(UserContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,conf.seo);

    useHandleSeoSettings(seoSettingsState);

    const [defaultFilter] = useState({
        type: 'ALL',
        desc: labels['prematch_page.temporal_filters.all'],
        hours: null
    });
    const cacheRef = useRef({
        tournaments: new Map(),
        autocomplete: null,
        widgets: null
    });
    const [state, setState] = useState({
        data: prematchDataContext,
        cache: cacheRef.current,
        section: 'landing-menu',
        sport: null,
        category: null,
        tournament: null,
        tournamentEvents: null,
        match: null,
        statsUrl: null,
        showStats: false,
        temporalFilter: defaultFilter,
        openedFromFavorites: false,
        goBackToEventsByDate: false,
        favoriteTournaments: (() => {
            let favorites = localStorage.getItem('favorite_tournaments');
            if (favorites != null) {
                favorites = JSON.parse(favorites);
                // Find the tournaments that are not present in the prematch data, if any
                const toRemove = [];
                Object.keys(favorites).forEach(f => {
                    if (prematchDataContext.tournamentByUniqueId[f] === undefined) {
                        toRemove.push(f);
                    }
                });
                if (toRemove.length > 0) {
                    // Remove the expired tournaments
                    toRemove.forEach(t => {
                        delete favorites[t];
                    });
                    // // Set the new list in the local storage or remove the item altogether
                    // if (Object.keys(favorites).length > 0) {
                    //     localStorage.setItem('favorite_tournaments', JSON.stringify(favorites));
                    // } else {
                    //     localStorage.removeItem('favorite_tournaments');
                    // }
                }
                return favorites;
            } else {
                return {};
            }
        })(),
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        openPrematchNoEvents(){
            this.update({section: 'prematch-no-events', selections: null});
        },
        openMenu() {
            if (this.section === 'events-by-date') {
                this.update({
                    section: 'landing-menu', 
                    sport: null, 
                    category: null, 
                    tournament: null, 
                    match: null, 
                    showStats: false, 
                    temporalFilter: defaultFilter
                });
            } else {
                let section = 'landing-menu';
                this.update({
                    section,
                    sport: null, 
                    category: null, 
                    tournament: null, 
                    match: null, 
                    showStats: false,
                    temporalFilter: defaultFilter
                });
            }
        },
        openTopMatchMenu(tournament) {
            this.update({
                section: 'topMatch-menu', 
                sport: null, 
                category: null, 
                tournament: tournament, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        },
        openSport(sport) {
            if (this.section === 'events-by-date') {
                this.update({
                    //section: 'landing-menu',
                    section: 'landing-menu',
                    sport, 
                    category: null, 
                    tournament: null, 
                    match: null, 
                    showStats: false, 
                    temporalFilter: defaultFilter, 
                    openedFromFavorites: false,
                    goBackToEventsByDate: false
                });
            } else {
                this.update({
                    //section: 'landing-menu',
                    section: 'landing-menu',
                    sport, 
                    category: null, 
                    tournament: null, 
                    match: null, 
                    showStats: false, 
                    openedFromFavorites: false,
                    goBackToEventsByDate: false
                });
            }
        },
        openCategory(category, goBackToEventsByDate = true) {
            if (this.goBackToEventsByDate && goBackToEventsByDate) {
                this.update({
                    section: 'events-by-date',
                    sport: null,
                    tournament: null,
                    match: null, 
                    showStats: false,
                    goBackToEventsByDate: false
                });
            } else {
                const sport = this.data.sportById[category.sportRef];
                this.update({
                    section: 'tournament-menu',
                    sport,
                    category, 
                    tournament: null, 
                    match: null, 
                    showStats: false,
                    goBackToEventsByDate: false
                });
            }
        },
        openTournament(tournament, openedFromFavorites) {
            if (openedFromFavorites) {
                this.update({
                    section: 'tournament',
                    tournament, 
                    match: null, 
                    showStats: false, 
                    temporalFilter: defaultFilter, openedFromFavorites
                });
            } else {
                this.update({
                    section: 'tournament',
                    tournament, 
                    match: null, 
                    showStats: false
                });
            }
        },
        openTournamentFromEventsByDate(tournament) {
            this.update({
                section: 'tournament',
                tournament, 
                match: null, 
                showStats: false,
                goBackToEventsByDate: true
            });
        },
        openMatch(match, isBetBuilderEvent = false) {
            const section = isBetBuilderEvent ? 'bet-builder-event' : match.isLive ? 'live-match' : 'match';
            if (this.section === 'events-by-date') {
                this.update({section, match, 
                    showStats: false, 
                    temporalFilter: defaultFilter
                });
            } else {
                this.update({section, match, 
                    showStats: false
                });
            }
        },
        openMatchFromTournament(tournament, match) {
            if (match.isLive) {
                this.update({
                    section: 'live-match',
                    tournament,
                    match, 
                    showStats: false
                });
            } else {
                this.update({
                    section: 'match',
                    tournament,
                    match, 
                    showStats: false
                });
            }
        },
        openMatchFromSearch(match) {
            this.update({
                section: 'match', 
                sport: null, 
                category: null, 
                tournament: null,
                match, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        },
        openTopMatch() {
            this.update({
                section: 'top-match', 
                sport: null, 
                category: null, 
                tournament: null, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter, 
                openedFromFavorites: false,
                goBackToEventsByDate: false
            });
        },
        openLastMinute() {
            this.update({
                section: 'last-minute', 
                sport: null, 
                category: null, 
                tournament: null, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        },
        openStatistics(url) {
            this.update({
                section: 'statistics', 
                statsUrl: url
            });
        },
        openResults(url) {
            this.update({
                section: 'results', 
                statsUrl: url
            });
        },
        toggleStats(url) {
            this.update({
                statsUrl: url, 
                showStats: !this.showStats
            });
        },
        openFavoriteTournaments() {
            this.update({
                section: 'favorite-tournaments', 
                sport: null, 
                category: null, 
                tournament: null, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        },
        setTemporalFilter(temporalFilter) {
            // if (this.temporalFilter.type === temporalFilter.type) {
            //     this.update({
            //         section: 'landing-menu',
            //         temporalFilter: defaultFilter
            //     });
            //     return;
            // }
            let openLanding = false;
            if (temporalFilter.type !== 'ALL') {
                if (TIME_FILTERS.includes(temporalFilter.type)) {
                    if (this.sport && !this.sport.filters[temporalFilter.type]) {
                        openLanding = true;
                    } else if (this.category && !this.category.filters[temporalFilter.type]) {
                        openLanding = true;
                    } else if (this.match) {
                        if (temporalFilter.hours != null) {
                            const maxDate = nHoursFromNow(temporalFilter.hours);
                            if (this.match.timestampDB > maxDate) {
                                openLanding = true;
                            }
                        } else {
                            const maxDate = nDaysFromNow(temporalFilter.days);
                            const date = this.match.timestampDB.split(' ')[0];
                            if (date > maxDate) {
                                openLanding = true;
                            }
                        }
                    }
                    if (openLanding || this.section === 'events-by-date') {
                        this.update({
                            section: 'landing-menu', 
                            sport: null, 
                            category: null, 
                            tournament: null, 
                            match: null, 
                            showSearch: false,
                            temporalFilter, 
                            openedFromFavorites: false,
                            goBackToEventsByDate: false
                        });
                    } else {
                        this.update({
                            temporalFilter
                        });
                    }
                } else {
                    this.update({
                        section: 'events-by-date', 
                        sport: null, 
                        category: null, 
                        tournament: null, 
                        match: null, 
                        showSearch: false,
                        temporalFilter, 
                        openedFromFavorites: false,
                        goBackToEventsByDate: false
                    });    
                }
            } else {
                this.update({
                    section: 'landing-menu',
                    temporalFilter
                });
            }
        },
        openMultiEventsByDate(temporalFilter) {
            this.update({
                section: 'events-by-date',
                temporalFilter
            });
        },
        toggleFavoriteTournament(id) {
            if (this.favoriteTournaments[id] === undefined) {
                this.favoriteTournaments[id] = true;
            } else {
                delete this.favoriteTournaments[id];
            }
            if (Object.keys(this.favoriteTournaments).length > 0) {
                this.update({
                    favoriteTournaments: {...this.favoriteTournaments}
                });
                localStorage.setItem('favorite_tournaments', JSON.stringify(this.favoriteTournaments));
            } else {
                if (this.section === 'favorite-tournaments') {
                    this.update({
                        favoriteTournaments: {}, 
                        section: 'landing-menu', 
                        sport: null, 
                        category: null, 
                        tournament: null, 
                        match: null, 
                        showStats: false
                    });
                } else {
                    this.update({
                        favoriteTournaments: {}
                    });
                }
                localStorage.removeItem('favorite_tournaments');
            }
        },
        applyTemporalFilter(items) {
            if (TIME_FILTERS.includes(this.temporalFilter.type)) {
                return items.filter(item => item.filters[this.temporalFilter.type])
            } else {
                return items;
            }
        },
        openFavoriteOdds() {
            this.update({
                section: 'favorite-odds',
                sport: null, 
                category: null, 
                tournament: null, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        },
        openExtraEvents() {
            this.update({
                section: 'extra-events',
                sport: null, 
                category: null, 
                tournament: null, 
                match: null, 
                showStats: false, 
                temporalFilter: defaultFilter
            });
        }
    });

    const handledOpenFromPath = useRef(false);
    useEffect(() => {
        if(props.openFromPath == null && !props.routeNotFound){
            //handledOpenFromPath.current = true;
            state.openSport(0);
        }
        if (props.openFromPath && appContext.handleOpenFromPath && state.data) {
            //handledOpenFromPath.current = true;
            if (props.openFromPath.sport) {
                const _existsSport = existsSport(state.data,props.openFromPath.sport.sportId);
                if (_existsSport) {
                    state.openSport(_existsSport);
                }else if (conf.seo) {
                    state.openPrematchNoEvents();
                }
            }
            if (props.openFromPath.country) {
                const _existsCountry = existsCountry(state.data,props.openFromPath.country.sportId,props.openFromPath.country.countryId);
                if(_existsCountry){
                    state.openCategory(_existsCountry);
                }else if (conf.seo) {
                    state.openPrematchNoEvents();
                }
            }
            if (props.openFromPath.tournament) {
                const _existsToutnament = existsTournament(state.data,props.openFromPath.tournament.sportId,props.openFromPath.tournament.countryId,props.openFromPath.tournament.tournamentId);
                if(_existsToutnament){
                    state.openTournament(_existsToutnament.uniqueId);
                }else if (conf.seo) {
                    state.openPrematchNoEvents();
                }
            }
           
            if(!props.openFromPath.match && !props.openFromPath.dateFilter){
                appContext.setHandleOpenFromPath(false);
            }
            handledOpenFromPath.current = true;

        }

        setLiveEventsNumber(state.data.nel);
        setBetslipEventsNumber(betslipContext.getCouponSelectionsNum());
    }, [state.data, props.openFromPath]);

    useEffect(() => {
        if (props.section === 'betslip') {
            !isBetslipPlayDirectRequest() && appContext.toggleBetslip();
        }
        if (props.section === 'mybets') {
                appContext.toggleMyBets();
        }
        if (props.section === 'checkbet') {
                appContext.toggleCheckBet();
        }
        if (props.section === 'checksystembets') {
            appContext.toggleCheckSystemBets();
    }
        if (props.section === 'top-match') {
                state.openTopMatch();
        }
    }, []);

    useEffect(() => {
        if (props.section === 'betslip') {
            if (isBetslipPlayDirectRequest()) {
                appContext.toggleBetslip();
            }
        }
     },[userContext.user]);

    const hideWrapper = isOverlaySection(appContext,props.section,userContext.user);
    const [, setNotFound] = useState(false);

    window.toggleFavoriteOdds = function() {
        state.openFavoriteOdds();
    }

    const routeMatch = useRouteMatch();
    let routeUrl = routeMatch?routeMatch.url:"";
    const renderContent = appConfig.ROUTES.routeFromPath (routeUrl) === 'prematch' || !props.routeNotFound || seoContext?.location;
    
    return (
        <>
            {props.routeNotFound && <RouteSeoPath {...props.routeProps} setNotFound={setNotFound} />}
            { 
            (!appContext.seoRoutePath && props.openFromPath && appContext.handleOpenFromPath && !handledOpenFromPath.current)?
            <Loader />
            : 
            (renderContent && 
                <PrematchContext.Provider value={state}>
                    <div id="main-wrapper" className={"wrapper" + classIf(hideWrapper, 'no-scroll d-none')}>
                        <div id="main-container" className="main-content">
                            {conf.smtm && 
                                <TopMenuSelector data={state.data} />
                            }
                            {conf.fan ?
                                <div className="navbars-container">
                                    {/* <MainMenuNavbar /> */}
                                    <SearchNavbar />
                                </div>
                                :
                                <SportSelector data={state.data} sport={state.sport} />
                            }
                            <div className="carousel-wrapper">
                                {conf.mbep &&
                                    <BannersFetcher />
                                }
                            </div>
                            {function() {
                                switch(state.section) {
                                    default:
                                    case 'landing-menu':
                                        return <LandingSports data={state.data} sport={state.sport} />
                                    case 'topMatch-menu':
                                        return <TopMatchMenu data={state.data} />
                                    case 'category-menu':
                                        return <CategoryMenu data={state.data} sport={state.sport} />
                                    case 'tournament-menu':
                                        return <TournamentMenu data={state.data} category={state.category} />
                                    case 'tournament':
                                        return <TournamentDataFetcher data={state.data} tournament={state.tournament} openFromPath={props.openFromPath} />
                                    case 'match':
                                        return <MatchDataFetcher match={state.match} />
                                    case 'top-match':
                                        return <TopMatch data={state.data} />
                                    case 'events-by-date':
                                        if (conf.dewas) {
                                            return <MultiEventsByDate data={state.data} filter={state.temporalFilter} />
                                        } else {
                                            return (
                                                <ExpandedViewProvider>
                                                    <EventsByDate data={state.data} />
                                                </ExpandedViewProvider>
                                            );
                                        }
                                    case 'last-minute':
                                        return <LastMinute data={state.data} />;
                                    case 'statistics':
                                        return <Statistics url={state.statsUrl} />;
                                    case 'results':
                                        return <Results url={state.statsUrl} />;
                                    case 'favorite-tournaments':
                                        return <FavoriteTournaments data={state.data} />;
                                    case 'live-match':
                                        return <PrematchLiveMatch match={state.match} />;
                                    case 'favorite-odds':
                                        return <FavoriteOdds />;
                                    case 'extra-events':
                                        return <ExtraEvents />;
                                    case 'prematch-no-events':
                                        return <PrematchNoEvents/>;
                                    case 'bet-builder-event':
                                        return <BetBuilderEventFetcher match={state.match} />;
                                }
                            }()}
                        </div>
                    </div>
                </PrematchContext.Provider>
            )
            }
        </>            
    );
}

export default Prematch;